var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMailIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 21 18",
    style: {
      enableBackground: "new 0 0 21 18"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;}\r\n\t.st1{fill:#888888;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_40",
    transform: "translate(-528 -328)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "iconPhone",
    transform: "translate(520 320)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "email_1",
    transform: "translate(8 8)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "email_1_Background_Mask_",
    className: "st0",
    d: "M-1.2-2.5h23v23h-23V-2.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    className: "st1",
    d: "M19.7,3.7c-0.6-2-2.5-3.4-4.6-3.4H5.5C3.4,0.3,1.6,1.7,1,3.7l9.4,5.1L19.7,3.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    className: "st1",
    d: "M10.3,10.9c-0.2,0-0.3,0-0.5-0.1l-9.1-5v7c0,2.6,2.1,4.8,4.8,4.8h9.6c2.6,0,4.8-2.1,4.8-4.8 v-7l-9.1,5C10.6,10.8,10.5,10.9,10.3,10.9z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailIcon);
export default __webpack_public_path__ + "static/media/mail-icon.3b87a1e327592788a0831431ee7895b2.svg";
export { ForwardRef as ReactComponent };